export function generateEmptyFft(): number[] {
  return Array.from({ length: 24 }).map(() => 0);
}
